module.exports = __webpack_public_path__ + "static/media/Pomáháme.e47bd156.jpg";